import * as React from 'react';
import {classify} from 'src/utils/classify';

import {Button, MenuButton} from 'src/designSystem2021Components/buttons';
import type {Option} from 'src/designSystem2021Components/menu';
import makeClassNameComponent, {
  type ClassNameComponent,
} from 'src/utils/makeClassNameComponent';

import css from './tablist.css';


export type Tab = Option & {
  subTabs?: Array<Option>;
};

export type Props = {
  tabs: Array<Tab>;
  onSelected: (option: Option) => unknown;
  selectedOption: Option;
  className?: string;
};

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
const TabItem: ClassNameComponent = makeClassNameComponent(css.tabItem);

export const TabList = (props: Props) => {
  const {tabs = {}, onSelected, selectedOption} = props;

  return (
    <div className={classify(css.wrapper, props.className)}>
      {/* @ts-expect-error - TS2339 - Property 'map' does not exist on type '{}'. | TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'label' implicitly has an 'any' type. | TS7031 - Binding element 'subTabs' implicitly has an 'any' type. */}
      {tabs.map(({key, label, subTabs}) => {
        //note: (aditya a) think of a better way to do this
        const isSelected = subTabs
          ? key === selectedOption.key.split('.')[0]
          : key === selectedOption.key;
        return (
          <TabItem key={key} className={css.tab}>
            {subTabs ? (
              <MenuButton
                menuOptions={subTabs}
                onMenuSelect={onSelected}
                selectedOption={selectedOption}
                buttonProps={{
                  className: classify({
                    [css.selected]: isSelected,
                  }),
                  isSelected,
                  isSelectable: true,
                  type: 'nav',
                }}
              >
                {label}
              </MenuButton>
            ) : (
              <Button
                className={classify({
                  [css.selected]: isSelected,
                })}
                onClick={() => onSelected({key, label})}
                isSelected={isSelected}
                isSelectable
                type="nav"
              >
                {label}
              </Button>
            )}
          </TabItem>
        );
      })}
    </div>
  );
};
